import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ search }) =>
    search ? "position: relative; margin: 0;" : "margin: 0 0 20px;"}

  input,
  textarea {
    display: block;
    width: 100%;
    padding: 8px 14px;
    ${({ search }) => search && "padding-left: 32px;"}
    border: 1px solid;
    border-color: ${({ hasErrors }) =>
      hasErrors ? "red" : "var(--border-shadow)"};
    border-radius: 6px;
    background: var(--white);
    font-size: 14px;

    &:focus {
      filter: drop-shadow(0px 0px 2px var(--brand));
    }

    &:disabled {
      opacity: 0.5;
    }
  }

  textarea {
    min-height: 100px;
  }

  ${({ search }) =>
    search &&
    css`
      input {
        height: 40px;
      }

      > span {
        z-index: 1;
        position: absolute;
        left: 6px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        opacity: 0.4;
      }
    `}
`;

export const Label = styled.label`
  display: block;
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: var(--gray);
`;

export const Error = styled.p`
  display: block;
  font-weight: 600;
  color: red;
`;
